import { Link } from "react-router-dom";
import PublicLayout from "@/components/PublicLayout";
import Seo from "@/components/Seo";

export default function About() {
  return (
    <PublicLayout>
      <Seo title="About Site Cleanup" description="Site Cleanup is an Australian lead-generation platform that matches site clean-up enquiries with suitable local contractors." />
      <section className="bg-asphalt text-white py-20">
        <div className="rs-container">
          <span className="rs-eyebrow text-safety">About</span>
          <h1 className="mt-3 text-5xl md:text-7xl uppercase max-w-3xl">Built for site clean-up. Built for the way construction actually works.</h1>
        </div>
      </section>
      <section className="py-20">
        <div className="rs-container grid md:grid-cols-2 gap-12">
          <div>
            <h2 className="text-3xl uppercase font-display">What we do</h2>
            <p className="mt-4 text-muted-foreground">Site Cleanup is an Australian lead-generation and quote-matching platform. We take enquiries from builders, land owners, developers and new home buyers who need a site cleared, and we match those enquiries with suitable local contractors — where availability, waste type and site conditions allow.</p>
            <p className="mt-4 text-muted-foreground">We're not a licensed waste operator ourselves. We connect real jobs with real crews.</p>
          </div>
          <div>
            <h2 className="text-3xl uppercase font-display">What we don't do</h2>
            <ul className="mt-4 space-y-3 text-muted-foreground list-disc pl-5">
              <li>We don't claim to be licensed, insured or EPA-approved unless a specific contractor holds those credentials and is confirmed for your job.</li>
              <li>We don't handle asbestos, contaminated soil, chemicals or hazardous waste directly. Those require licensed specialists.</li>
              <li>We don't guarantee same-day service. Timing depends on contractor availability and site conditions.</li>
              <li>We don't claim to be the cheapest — we focus on getting the right contractor for the site.</li>
            </ul>
          </div>
        </div>
      </section>
      <section className="py-16 bg-white border-t border-border">
        <div className="rs-container flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <h3 className="font-display text-3xl uppercase">Ready to send us your site?</h3>
          <Link to="/request-quote" className="rs-btn-primary">Request a Site Clean-Up Quote</Link>
        </div>
      </section>
    </PublicLayout>
  );
}
